import { createTranslations } from '@npco/utils-translations'

export const translations = createTranslations({
  amountLabel: 'Amount',
  amountRangeLabel: 'Amount Range',
  maxError: 'Max value must be equal or greater than Min value.',
  minError: 'Min value must be less than Max value.',
})
